module.exports = __webpack_public_path__ + "static/Residential_Masthead-13424230a55a1b65d56fce9cb8e6c0d2.jpg";